import { apiV2 } from "./axiosConfig";
import { GeocodeResponse } from "../types/geocode";

export async function searchAddress(query: string): Promise<GeocodeResponse[]> {
    if (!query || query.trim() === "") {
        return [];
    }

    try {
        const response = await apiV2.get<GeocodeResponse[]>("geo/geocode", {
            params: { query }
        });
        return response.data;
    } catch (error) {
        console.error("Error searching address:", error);
        return [];
    }
}
